import React, { Fragment, useState, useEffect } from "react";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import Calendar from "react-calendar";
import Select from "react-select";
import "react-calendar/dist/Calendar.css";
import { Table, Checkbox } from "semantic-ui-react";
import moment from "moment";
let dayArr = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const FormAddHolidayCalender = (props) => {
  const { inputFields, formValidation,holidaycal,WeekdayId,handleCheckCheckBox,selectedYearList } = props;
  const [calenderDate] = useState(new Date());
  const [date, setDate] = useState();
  const [day, setDay] = useState("");
  const [year, setYear] = useState("");

  const onChange = (date) => {
    // setDate(date);
    setDate(date.getDate());
    setDay(dayArr[date.getDay()]);
    setYear(date.getFullYear());
    props.handleOnchangeDate(date);
  };
  let holidaylist=[];
  if (Array.isArray(holidaycal)) {
    holidaycal.map(function (hol){
      holidaylist.push(moment(hol.holidayDate).format('DD-MM-YYYY'));
    })
  }
  useEffect(() => {
    if (props.formData !== undefined) {
      let incomingDate = new Date(props.formData.val.holidayDate);
     
      setDate(incomingDate.getDate());
      setDay(dayArr[incomingDate.getDay()]);
      setYear(incomingDate.getFullYear());
    }
  }, [props.formData]);
  let selectedoptions=[];
  let selectedoptions1=[];
  let selectedoptions2=[];
  let options=[];
  let options1=[];
  let options2=[];
  const uniqueLocations = [];
  if (Array.isArray(inputFields)) {
    inputFields.map(function (desig) {
  if(desig.type=="multipleselect" && desig.option.length >0)
   {
    
    desig.option.map((el,i) =>{
     options.push({value: el.officeLocationId, label: el.address }); 
     // props.handlesetAttribute(props.formData.val.designation);
     props.formData.val.locationId.split(',').map(function (desId, index) {
       if(parseInt(desId)==el.officeLocationId)
       {
        if(selectedoptions.length >0)
        {
       const hhh=   selectedoptions.some(element => {
            if (element.value === parseInt(desId)) {
              return true;
            }
            else
            {
              return false
            }
          });
          if(hhh==false)
          {
            selectedoptions.push({value: el.officeLocationId, label: el.address });
          }
        }
        else
        {
          selectedoptions.push({value: el.officeLocationId, label: el.address });
        }
          
       }
   });
    
    })
   
   }
   else if(desig.type=="multipleselect1" && desig.option.length >0)
   {
   
    desig.option.map((el,i) =>{
     options1.push({value: el.departmentId, label: el.departmentName }); 
     // props.handlesetAttribute(props.formData.val.designation);
     props.formData.val.department.split(',').map(function (desId, index) {
       if(parseInt(desId)==el.departmentId)
       {
        if(selectedoptions1.length >0)
        {
       const kkk=   selectedoptions1.some(element => {
            if (element.value === parseInt(desId)) {
              return true;
            }
            else
            {
              return false;
            }
          });
          if(kkk==false)
          {
            selectedoptions1.push({value: el.departmentId, label: el.departmentName });
          }
        }
        else{
          selectedoptions1.push({value: el.departmentId, label: el.departmentName });
        }
       
         
       }
   });
    
    })
   
   }
   else if(desig.type=="select" && desig.option.length >0)
   {

    desig.option.map((el,i) =>{
      options2.push({value: el.calanderyearId, label: el.description }); 
     // props.handlesetAttribute(props.formData.val.designation);
    //  props.formData.val.holidayCalendarId.map(function (desId, index) {
       if(parseInt(props.formData.val.calendarYearId)==el.calanderyearId)
       {
       
          selectedoptions2.push({value: el.calanderyearId, label: el.description });
        
       
         
       }
  //  });
    
    })

   }
 })
  }
 const users = [
  {id: 1, name: 'Sunday'},
  {id: 2, name: 'Monday'},
  {id: 3, name: 'Tuesday'},
  {id: 4, name: 'Wednesday'},
  {id: 5, name: 'Thursday'},
  {id: 6, name: 'Friday'},
  {id: 7, name: 'Saturday'},
];
const TableRow = React.memo(({ selected, id, label }) => {
  var bbb=selected.includes(String(id)) ? true :false ;
  return (
    <Table.Row>
      <Table.Cell>
        <Checkbox 
          id={id}
          checked={selected.includes(String(id)) ? true :false} 
          onChange={(e) => {
            handleCheckCheckBox(e.target.id,0);
          }}
        />
      </Table.Cell>
      <Table.Cell>{label}</Table.Cell>
    </Table.Row>
  );
});
  return (
    <Fragment>
      <Form>
        <Row form>
          <Col md={4}>
            <Calendar onChange={onChange} value={calenderDate}  tileClassName={({ date, view }) => {
                if(holidaylist.find(x=>x===moment(date).format("DD-MM-YYYY"))){
                 return  'highlight'
                }
              }}/>
              <Table>
      <Table.Header>
      <Table.Row>
        <Table.HeaderCell />
        <Table.HeaderCell>Set Non Working Days (Recurring)</Table.HeaderCell>
      </Table.Row>
      </Table.Header>
      <Table.Body>
          {users.map((user) => 
              <TableRow 
                key={user.id} 
                id={user.id}
                label={user.name}  
                selected={WeekdayId}
              />
          )}
      </Table.Body>
    </Table>
          </Col>
          <Col md={8}>
            {inputFields !== undefined
              ? inputFields.map((inputField, i) => {
                  return (
                    <FormGroup key={i}>
                      <Label>{inputField.label}</Label>
                      { inputField.type != "multipleselect" &&  inputField.type != "multipleselect1" &&  inputField.type != "select" ? (
                      <Fragment>
                      <Input
                        type={inputField.type}
                        placeholder={inputField.placeholder}
                        onChange={(e) => {
                          inputField.handleOnChange(e.target.value);
                          props.handleOnchangeToSelectedData(
                            e.target.value,
                            inputField.name
                          );
                        }}
                        value={props.formData.val[inputField.name]}
                      />
                      {Object.keys(formValidation).length !== 0 &&
                        !formValidation?.[inputField.name]?.isValid && (
                          <span className=" " style={{ color: "red" }}>
                            {formValidation?.[inputField.name]?.errorMessage}
                          </span>
                        )} </Fragment>) :((inputField.type === "multipleselect" ? (inputField.option.length >0 ? (
                 
                          <Fragment>
         {/* <Label>{inputField.label}</Label> */}
                   <Select style={{color:"black"}}
                 isMulti defaultValue={ selectedoptions.map(ele => ele) }  options={options}  onChange={(e) => {
                   inputField.handleOnChange(e[e.length-1].value,0);
                 }}>
                    
                  
                   </Select>
                          </Fragment>
                        ) : null) : (inputField.type === "multipleselect1" ? (inputField.option.length >0 ? (
                 
                          <Fragment>
         {/* <Label>{inputField.label}</Label> */}
                   <Select style={{color:"black"}}
                 isMulti defaultValue={ selectedoptions1.map(ele => ele) }  options={options1}  onChange={(e) => {
                   inputField.handleOnChange(e[e.length-1].value,0);
                 }}>
                    
                  
                   </Select>
                          </Fragment>
                        ) : null) :( <Fragment>
                          {/* <Label>{inputField.label}</Label> */}
                          {/* <Input
                            type={inputField.type}
                            placeholder={inputField.placeholder}
                            onChange={(e) => {
                              inputField.handleOnChange(e.target.value);
                            }}
                          >
                            <option value="0">----Select----</option>
                            {inputField.option.map((el, i) => (
                             <option 
                              key={i} 
                              value={el[inputField.displayData["id"]]}
                              >
                                {el[inputField.displayData["selectedData"]]}
                              </option>
                            ))}
                          </Input> */}
                          <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={options2[0]}
        onChange={(e) => {
          inputField.handleOnChange(e.value,e.label,e);
        }} 
        value={selectedoptions2}
        isSearchable={true}
        name="color"
        options={options2}
      />
                        </Fragment>))))

            }
                    </FormGroup>
                  );
                })
              : null}
            <Row form>
              <Col md={4}>
                <FormGroup>
                  <Label>Date</Label>
                  <Input
                    type="text"
                    placeholder="Select Date"
                    value={date}
                    disabled
                    // value={props.formData ? props.formData.val[val.name] : null}
                  />
                  {Object.keys(formValidation).length !== 0 &&
                    !formValidation?.date?.isValid && (
                      <span className=" " style={{ color: "red" }}>
                        {formValidation?.date?.errorMessage}
                      </span>
                    )}
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Day</Label>
                  <Input
                    type="text"
                    placeholder="Select Date"
                    value={day}
                    disabled
                    // value={props.formData ? props.formData.val[val.name] : null}
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Year</Label>
                  <Input
                    type="text"
                    placeholder="Select Date"
                    value={year}
                    disabled
                    // value={props.formData ? props.formData.val[val.name] : null}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button
              color=""
              className="btn-admin-settings"
              onClick={props.handleSubmit}
            >
              {props.button}
            </Button>{" "}
            &nbsp;
            <Button color="" className="btn-cancel" onClick={props.toggle}>
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};

export default FormAddHolidayCalender;
